export default "__VITE_ASSET__12335e47__"